import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed, watch } from 'vue';
import { ModalHeader, ModalWrap, ModalBody } from '@/user/components/common/';
import { setModalDimmed } from '@/user/homepage-integration';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        modelValue: { type: Boolean },
        size: {},
        title: {},
        verticalAlign: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        function closeModal() {
            isOpen.value = false;
        }
        watch(isOpen, async (newValue) => {
            setModalDimmed(newValue);
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (isOpen.value)
                ? (_openBlock(), _createBlock(_unref(ModalWrap), {
                    key: 0,
                    size: __props.size,
                    "vertical-align": __props.verticalAlign || 'center',
                    onClose: closeModal
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(ModalHeader), {
                            size: __props.size,
                            title: __props.title
                        }, {
                            header: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "header")
                            ]),
                            _: 3
                        }, 8, ["size", "title"]),
                        _createVNode(_unref(ModalBody), { size: __props.size }, {
                            content: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "content")
                            ]),
                            _: 3
                        }, 8, ["size"]),
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 8, ["size", "vertical-align"]))
                : _createCommentVNode("", true);
        };
    }
});
